import { createAuthToggle } from "@jkast90/kast-common/auth";
import { deploymentConfig } from "./deploymentConfig";

/**
 * The workspace API base URL, read fresh each call so a settings change
 * applies at once.
 */
export function getWorkspaceApiBaseUrl(): string {
  return deploymentConfig.get("apiUrl");
}

export function getCognitoDomain(): string {
  // NEVER use localStorage for Cognito config - always use deployment config
  // This ensures we always use the correct AWS Cognito instance
  return deploymentConfig.get().cognitoDomain;
}

export function getCognitoClientId(): string {
  // NEVER use localStorage for Cognito config - always use deployment config
  // This ensures we always use the correct AWS Cognito client ID
  return deploymentConfig.get().clientId;
}

// Auth settings. The runtime config decides when it sets DISABLE_AUTH (the
// deployed site's public/config.js says "false", so it always signs in);
// otherwise this device's Settings toggle (kast-common's switch) does.
const authToggle = createAuthToggle();

export function getAuthEnabled(): boolean {
  const { disableAuth } = deploymentConfig.get();
  if (disableAuth) return disableAuth !== "true";
  return authToggle.get();
}

export const setAuthEnabled = authToggle.set;

export function getBypassEmail(): string {
  try {
    const ls = window.localStorage.getItem("bypass_email");
    return ls || "";
  } catch {
    return "";
  }
}

export function setBypassEmail(email: string): void {
  try {
    window.localStorage.setItem("bypass_email", email);
  } catch {
    /* ignore */
  }
}
